import React from 'react';

export const ToastGradientWarning = () => (
  <svg
    width='87'
    height='100%'
    viewBox='0 0 87 57'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_809_3792)'>
      <circle cy='28' r='87' fill='url(#paint0_radial_809_3792)' fillOpacity='0.11' />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_809_3792'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(0 28) rotate(90) scale(87)'
      >
        <stop stopColor='#FF8C21' />
        <stop offset='1' stopColor='#FF8C21' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_809_3792'>
        <rect width='87' height='57' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastGradientSuccess = () => (
  <svg
    width='87'
    height='100%'
    viewBox='0 0 87 57'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_268_9436)'>
      <circle cy='28' r='87' fill='url(#paint0_radial_268_9436)' fillOpacity='0.12' />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_268_9436'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(0 28) rotate(90) scale(87)'
      >
        <stop stopColor='#00B42A' />
        <stop offset='1' stopColor='#00B42A' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_268_9436'>
        <rect width='87' height='57' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastGradientInfo = () => (
  <svg
    width='87'
    height='100%'
    viewBox='0 0 87 57'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_784_18907)'>
      <circle cy='28' r='87' fill='url(#paint0_radial_784_18907)' fillOpacity='0.11' />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_784_18907'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(0 28) rotate(90) scale(87)'
      >
        <stop stopColor='#001EA3' />
        <stop offset='1' stopColor='#001EA3' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_784_18907'>
        <rect width='87' height='57' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastGradientError = () => (
  <svg
    width='87'
    height='100%'
    viewBox='0 0 87 57'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_268_9423)'>
      <circle cy='28' r='87' fill='url(#paint0_radial_268_9423)' fillOpacity='0.13' />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_268_9423'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(0 28) rotate(90) scale(87)'
      >
        <stop stopColor='#F04248' />
        <stop offset='1' stopColor='#F04248' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_268_9423'>
        <rect width='87' height='57' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastWarningIcon = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_768_5156)'>
      <path
        d='M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM13 17.5H11V15.5H13V17.5ZM13 13.5H11V7.5H13V13.5Z'
        fill='#FF8C21'
      />
    </g>
    <defs>
      <clipPath id='clip0_768_5156'>
        <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastErrorIcon = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_268_9416)'>
      <path
        d='M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z'
        fill='#F04248'
      />
    </g>
    <defs>
      <clipPath id='clip0_268_9416'>
        <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastSuccessIcon = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_268_9429)'>
      <path
        d='M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z'
        fill='#00B42A'
      />
    </g>
    <defs>
      <clipPath id='clip0_268_9429'>
        <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const ToastInfoIcon = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5ZM11 7.5L13 7.5L13 9.5L11 9.5L11 7.5ZM11 11.5L13 11.5L13 17.5L11 17.5L11 11.5Z'
      fill='#355491'
    />
  </svg>
);
